import { Box, Icon, Link, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getReceipt } from 'services/api/modules/recruitment/order'
import { downloadUrlFile, notifyDownloadError } from 'services/helper/fileDownload'

const {
  default: AdxFullWindowTitleBar,
} = require('components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar')

const PaymentSuccessful = ({ isSuccess = true }) => {
  const navigate = useNavigate()

  //using params(credit purchase)
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const orderId = query.get('order_id')
  const amountPaid = query.get('amount_paid')
  const date = query.get('payment_date')
  const newDate = new Date(date ?? [])

  //change the timestamp to dd/mm/yyy, hh:mm am/pm format
  const newFormattedDate = newDate.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })

  //check of the time is in PM and the hour clock is 00, change it 12
  const [dateString, time] = newFormattedDate.split(', ')
  const [hour, minuteTemp] = time.split(':')
  const [minute, ampm] = minuteTemp.split(' ')
  const convertTime = (ampm, dateString, minuteTemp, hour, newFormattedDate) => {
    if (ampm === 'pm' && hour === '00') {
      return `${dateString}, 12:${minuteTemp}`
    } else {
      return newFormattedDate
    }
  }
  const updatedDate = convertTime(ampm, dateString, minuteTemp, hour, newFormattedDate)

  //api call for get receipt
  const [isLoadingDownload, setIsLoadingDownload] = useState(false)
  const handleDownload = async () => {
    setIsLoadingDownload(true)
    try {
      const pdfLink = await getReceipt(orderId)
      setIsLoadingDownload(false)
      downloadUrlFile({
        url: pdfLink,
        fileName: `${orderId}_invoice.pdf`,
        successMessage: 'Receipt downloaded.',
        revokeObjectUrl: true,
      })
    } catch (error) {
      setIsLoadingDownload(false)
      notifyDownloadError('Unable to download receipt. Please try again.')
      console.log(error)
    }
  }

  // close button action
  const handleClose = () => {
    navigate('/app/recruitment')
  }
  const returnToCart = () => {
    navigate('/app/recruitment/cart')
  }
  const goToCreditTopUp = () => {
    navigate('/app/recruitment/credit/top-up')
  }
  return (
    <Box bgcolor="gray-background.main" sx={{ height: '100%' }}>
      {isSuccess ? (
        <AdxFullWindowTitleBar onClose={handleClose}>Payment Successful</AdxFullWindowTitleBar>
      ) : (
        <AdxFullWindowTitleBar onClose={handleClose}>Payment Unsuccessful</AdxFullWindowTitleBar>
      )}
      <Box display="flex" justifyContent="center">
        <Box bgcolor="white.main" width={700} px={4} minHeight="calc(100vh - 59px)">
          {isSuccess ? (
            <Box display="flex" alignItems="center" flexDirection="column">
              <Icon
                sx={{
                  fontSize: '130px',
                  color: 'positive.main',
                }}
              >
                check_circle_icon
              </Icon>
              <Typography
                variant="h2"
                color="dark-text.main"
                marginTop={4}
                sx={{
                  fontWeight: 'bold',
                }}
              >
                Payment successful
              </Typography>
              <Typography
                marginTop={2}
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                Thank you, you have successfully made your payment for the following order ID.
              </Typography>
              <Typography
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                You can now view the purchased candidate.
              </Typography>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" flexDirection="column">
              <Icon
                sx={{
                  fontSize: '130px',
                  color: 'error.main',
                }}
              >
                cancel_icon
              </Icon>
              <Typography
                variant="h2"
                color="dark-text.main"
                marginTop={4}
                sx={{
                  fontWeight: 'bold',
                }}
              >
                Payment unsuccesful.
              </Typography>
              <Typography
                marginTop={2}
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                Unfortunately, your payment cannot be processed. Please try again.
              </Typography>
            </Box>
          )}

          {orderId !== null ? (
            <Box mt={4} px={4} py={1} bgcolor="gray-background.main">
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h4" color="light-gray-text.main">
                  Order ID
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  {orderId}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Transaction type
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  Credit purchase
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Amount paid
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  RM {amountPaid}.00
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Payment Date
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  {updatedDate}
                </Typography>
              </Box>
            </Box>
          ) : null}

          <Box marginTop={6} display="flex" flexDirection="column" alignItems="center">
            <Box display="flex" columnGap={0.5} marginBottom={1}>
              <Typography variant="body2" color="light-gray-text.main">
                Need help?
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {' '}
                <Link
                  onClick={() => window.open('https://adnexio.jobs/contact-us', '_blank')}
                  color="alternate.main"
                >
                  Contact Us
                </Link>
              </Typography>
              <Typography variant="body2" color="light-gray-text.main">
                for inquiries
              </Typography>
            </Box>
            <AdxButton
              variant={'contained'}
              size="standard"
              sx={{ width: 500 }}
              onClick={handleClose}
            >
              Return
            </AdxButton>
            {orderId !== null ? (
              <AdxButton
                variant={'outlined'}
                size="standard"
                sx={{ width: 500, marginTop: 1 }}
                onClick={handleDownload}
                isLoading={isLoadingDownload}
              >
                Download receipt
              </AdxButton>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export default PaymentSuccessful
